import { BasePicturesModel } from '@/models/BasePicturesModel'

export class InputNearestParent extends BasePicturesModel {
	static fields () {
		return {
			id: null,
			category: {
				id: null,
				name: null
			},
			oemCodes: {
				id: null,
				code: null,
				isPrimary: false
			},
			location: {
				id: null,
				name: null
			},
			comment: null,
			pictures: {
				id: null,
				url: null
			},
			isGroupedSale: false
		}
	}
}
export function createInputNearestParent (data) {
	return Object.freeze(new InputNearestParent(data))
}
